export class FiscalFileLocationDto {
id: string;
SiteId: string;
ModifiedById: string;
CreatedById: string;
dateUpdated: Date;
dateCreated: Date;
Version: Number;
FileLocationName: string;
SubscriberId: string;
SubscriptionUserId: string;
}
